import {isEmpty, isNOU} from "@/assets/plugins/mps-common/expansions/condition";

class UtilManager {
    stripHtml(html) {
        return html.replace(/(<([^>]+)>)/gi, "");
    }

    extractLocale(locale) {
        const languageMatch = /^\w{2}/.exec(locale);
        const countryMatch = /\w{2}$/.exec(locale);
        return {
            languageCode: languageMatch ? languageMatch[0] : null,
            countryCode: countryMatch ? countryMatch[0] : null,
        }
    }

    getImgUrl(src) {
        return require('@/assets/image/' + src);
    }

    getUniqueId() {
        return Math.random().toString(36).substr(2, 9);
    }

    trimAllSpaces(str) {
        try {
            if (isNOU(str)) return null;
            if (typeof str === 'number') {
                str = "" + str;
            } else if (typeof str !== 'string') {
                throw new Error("trim params s should be string, str is " + str);
            }
            return str.split(' ').join('');
        } catch (err) {
            console.error('PrinterModal trimAllSpaces Error! ' + err);
            return '';
        }
    }

    trim(s) {
        if (isNOU(s)) return null;
        if (typeof s !== 'string') {
            throw new Error("trim params s should be string");
        }
        return s.trim();
    }

    searchByKeyword(obj, keyword, keyArr) {
        if (!obj) throw new Error("obj must be Object");
        if (!keyword || !this.trimAllSpaces(keyword)) return true;
        if (isEmpty(keyArr)) throw new Error("keyArr must be array and not empty");
        for (let i = 0; i < keyArr.length; i++) {
            const key = keyArr[i];
            const str = this.byString(obj, key);
            if (!str || !this.trimAllSpaces(str)) continue;
            if (this.trimAllSpaces(str).toLowerCase().indexOf(this.trimAllSpaces(keyword).toLowerCase()) > -1) return true;
        }
        return false;
    }

    byString(o, s) {
        if (!s) return null;
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        let a = s.split('.');
        for (let i = 0, n = a.length; i < n; ++i) {
            let k = a[i];
            if (!isNOU(o[k]) && k in o) {
                o = o[k];
            } else {
                return null;
            }
        }
        return o;
    }

    assign(o, s, v) {
        if (!s) return null;
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        let a = s.split('.');
        for (let i = 0, n = a.length; i < n; ++i) {
            let k = a[i];
            if (k in o) {
                if (i < (n - 1)) {
                    o = o[k];
                } else {
                    o[k] = v;
                    o = o[k];
                }
            } else {
                return null;
            }
        }
        return o;
    }

    isEmpty(arr) {
        return isEmpty(arr);
    }

    isNotEmpty(arr) {
        return !isEmpty(arr);
    }

    /**
     * 첫 번째 인자로 넘어온 Object 를 두 번째 인자로 넘어온 String (. 으로 분리된) 의 구조에 맞춰
     * 빈 오브젝트로 채워준다. 마지막 (. 으로 분리된) 조각은 일치하는 데이터가 없을 경우 undefined 로 채워진다.
     *
     * ex) 첫 번재 인자: {}, 두 번째 인자: "raw.admin" => 결과: {raw: {admin: undefined}}
     */
    objectize(o, s) {
        if (!s) throw new Error("objectize: s is should be defiend!");
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        let a = s.split('.');
        for (let i = 0, n = a.length; i < n; ++i) {
            let k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                if (i === (n - 1)) {
                    o[k] = undefined;
                } else {
                    o[k] = {};
                    o = o[k];
                }
            }
        }
    }

    nextChar(c) {
        return String.fromCharCode(c.charCodeAt(0) + 1)
    }

    toChar(c, index) {
        return String.fromCharCode(c.charCodeAt(0) + index)
    }
}

const utilManager = new UtilManager();

export default utilManager;
